import { baseURL, moduleName } from "../../../controllers/api/globalEndpoint.api";

const chatbotEndPoint = {
    getChatbotList: baseURL + moduleName.auth + moduleName.chatbot + '/get-list',
    createChatbot: baseURL + moduleName.auth + moduleName.chatbot + '/create',
    deleteChatbotItem: baseURL + moduleName.auth + moduleName.chatbot + '/delete/',
};

export default chatbotEndPoint;